import { useState, useEffect, createElement, Fragment } from 'rax';
import classNames from 'classnames';
import Icon from './icons/index';
import { registerComponent, renderComponent, ComponentRenderParameter } from "../../common/component-manager";
import DotElement from '../common/dotElement';
import { jsonp } from '../../common/fetchData';
import Path from '../common/page-path';
import { parseQueryString } from '../../common/utils';
import './index.less';
interface navType {
  name: string;
  url?: string;
  action?: string;
  image: string;
  categoryId: string;
  trankInfo?: string; // 打点串

  children?: any;
}
interface TreePropsType {
  navMainName: string;
  givenMenuData?: navType[];
  config?: any;
  floorName?: string;
}

const getCategoryList = (categoryId: string | number, callback: any) => {
  jsonp({
    api: 'https://insights.alibaba.com/openservice/gatewayService',
    data: {
      modelId: 484,
      categoryIds: categoryId
    },
    onSuccess: (body: {
      data: {
        list: any;
      };
    }) => {
      if (body.data) {
        callback(body.data.list || []);
      }
    },
    onError: () => {}
  });
};

export default function CategroyTree(props: TreePropsType) {
  const {
    navMainName,
    givenMenuData = [],
    config = {},
    floorName
  } = props;
  const {
    isLinkBlank = false
  } = config;
  const [activeIndex, setActiveIndex] = useState(0);
  const [MenuData, setMenuData] = useState(givenMenuData);
  useEffect(() => {
    if (givenMenuData.length === 0) {
      const querys: any = parseQueryString();
      let params = {
        categoryIds: ""
      };

      if (querys.paramMap) {
        params = JSON.parse(decodeURIComponent(querys.paramMap));
      }

      getCategoryList(params.categoryIds, list => {
        setMenuData(list);
      });
    }
  }, []);
  return <div className="industry-category-tree">
      {navMainName && <div className="category-head">
        {navMainName}
      </div>}
      {MenuData.map((nav, index) => {
      return <div className="nav" key={index}>
            <div className="name">
              <DotElement type="nav" spmd={index} dotParams={{
            floorName: floorName || 'treenav',
            navNames: nav.categoryId,
            navLevel: '1',
            index: index.toString()
          }} htmlType="a" href={nav.url || nav.action} target={isLinkBlank ? '_blank' : '_self'}>
                 <Fragment>{nav.name}</Fragment> 
              </DotElement>
              {(nav.children === null || nav.children.length > 0) && <Icon className="opt industry_iconfont" type={activeIndex === index ? 'arrow_up' : 'arrow_down'} onClick={() => {
            if (nav.children === null) {
              getCategoryList(nav.categoryId, (list: any) => {
                nav.children = list;
                setMenuData(Object.assign([], MenuData));
              });
            }

            if (index === activeIndex) {
              setActiveIndex(-1);
            } else {
              setActiveIndex(index);
            }
          }} />}

            </div>
            <div className={classNames({
          subnav: true,
          hide: activeIndex !== index
        })}>
              {nav.children && nav.children.map((subnav: navType, subindex: number) => {
            return <div className="subname" key={subindex}>
                    <DotElement type="nav" spmd={subindex} dotParams={{
                floorName: floorName || 'treenav',
                navNames: subnav.categoryId,
                navLevel: '2',
                index: subindex.toString()
              }} htmlType="a" href={subnav.url || subnav.action} target={isLinkBlank ? '_blank' : '_self'}>
                        <Fragment>{subnav.name}</Fragment>
                    </DotElement>
                  </div>;
          })}
            </div>
          </div>;
    })}
    </div>;
}
registerComponent("left_category_nav", {
  render: ({
    moduleWarp,
    containerElement
  }: ComponentRenderParameter) => {
    const data = moduleWarp.data?.data;
    const opData = data.opData;
    const serverData = data;
    const containerEl = document.getElementById("left-category-nav"); // const rightContent = document.getElementById("right-content");

    if (serverData.categoryList && serverData.categoryList.length > 0) {// if(rightContent) {
      //   rightContent.className = rightContent.className + ' right-content';
      // }
    }

    if (serverData.pathList) {
      const pathDiv = document.getElementById("page-path");

      if (pathDiv) {
        pathDiv.innerHTML = "";
        pathDiv && renderComponent(<Path lists={serverData.pathList}></Path>, pathDiv);
      }
    }

    if (containerEl) {
      containerEl.innerHTML = "";
      renderComponent(<CategroyTree navMainName={opData.navMainName} givenMenuData={serverData.categoryList} />, containerEl);
    }
  }
});